
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import type { ArticleFormValues } from "./ArticleEditor";
import { Control } from "react-hook-form";

interface Props {
  control: Control<ArticleFormValues>;
}

export default function ArticleEditorTopic({ control }: Props) {
  return (
    <FormField
      control={control}
      name="topic"
      rules={{ required: "Topic is required" }}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-white/90">Topic</FormLabel>
          <FormControl>
            <Input placeholder="Article topic" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
